// import React, { useEffect } from "react";
// import * as Icons from "react-feather";
// import { Link, useLocation } from "react-router-dom";
// import { useAuth } from "../../store/auth";

// export default function MobileMenu() {
//   const [showMenu, setShowMenu] = React.useState(false);
//   const location = useLocation();
//   const [currentMenu] = location.pathname.slice(1).split("/");
//   const [activeMenu, setActiveMenu] = React.useState(currentMenu);
//   const auth = useAuth();
//   const toggler = () => {
//     setShowMenu(!showMenu);
//     setActiveMenu("");
//   };
//   useEffect(() => {
//     setShowMenu(false);
//   }, [location]);

//   return (
//     <>
//       <div className="mobile-menu md:hidden">
//         <div className="mobile-menu-bar">
//           <a href="" className="flex ml-auto">
//             <img alt="هاشور" className="h-8" src="/images-panel/hashure.svg" />
//           </a>
//           <a href="javascript:;" id="mobile-menu-toggler" onClick={toggler}>
//             {" "}
//             <Icons.BarChart2
//               data-feather="bar-chart-2"
//               className="w-8 h-8 text-white transform -rotate-90"
//             />
//           </a>
//         </div>
//         <ul
//           className={`border-t border-theme-29 py-5 ${
//             showMenu ? "" : "hidden"
//           }`}
//         >
//           {auth.userMeta &&
//             auth.userMeta.panel_menus &&
//             auth.userMeta.panel_menus.length > 1 &&
//             auth.userMeta.panel_menus.map((item) => (
//               <>
//                 {item.allow && (
//                   <li>
//                     <a
//                       href="javascript:;"
//                       onClick={() => {
//                         setActiveMenu(activeMenu == item.to ? "" : item.to);
//                       }}
//                       className={`menu ${
//                         activeMenu == item.to ? "menu--active" : ""
//                       }`}
//                     >
//                       <div className="menu__icon">
//                         <IconLoader name={item.icon} />
//                       </div>
//                       <div className="menu__title">
//                         {item.title}
//                         {item.childs.length > 1 && (
//                           <Icons.ChevronDown className="menu__sub-icon" />
//                         )}
//                       </div>
//                     </a>
//                     <ul
//                       className={`${
//                         activeMenu == item.to ? "menu__sub-open" : ""
//                       }`}
//                     >
//                       {item.childs &&
//                         item.childs.length > 0 &&
//                         item.childs.map((c_item) => (
//                           <>
//                             {c_item.allow && (
//                               <li>
//                                 <Link to={c_item.to} className="menu">
//                                   <div className="menu__icon">
//                                     <IconLoader name={c_item.icon} />
//                                   </div>
//                                   <div className="menu__title">
//                                     {c_item.title}
//                                   </div>
//                                 </Link>
//                               </li>
//                             )}
//                           </>
//                         ))}
//                     </ul>
//                   </li>
//                 )}
//               </>
//             ))}
//         </ul>
//       </div>
//     </>
//   );
// }
// const IconLoader = (props) => {
//   const Dicn = Icons[props.name];
//   return <Dicn {...props.rest} />;
// };

import React, { useEffect } from "react";
import * as Icons from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../store/auth";

export default function MobileMenu() {
  const [showMenu, setShowMenu] = React.useState(false);
  const location = useLocation();
  const [currentMenu] = location.pathname.slice(1).split("/");
  const [activeMenu, setActiveMenu] = React.useState(currentMenu);
  const auth = useAuth();

  const toggler = () => {
    setShowMenu(!showMenu);
    setActiveMenu("");
  };

  useEffect(() => {
    setShowMenu(false);
  }, [location]);

  return (
    <>
      <div className="mobile-menu md:hidden">
        <div className="mobile-menu-bar">
          <a href="#" className="flex ml-auto" onClick={(e) => e.preventDefault()}>
            <img alt="هاشور" className="h-8" src="/images-panel/hashure.svg" />
          </a>
          <a href="#" id="mobile-menu-toggler" onClick={(e) => { e.preventDefault(); toggler(); }}>
            <Icons.BarChart2
              data-feather="bar-chart-2"
              className="w-8 h-8 text-white transform -rotate-90"
            />
          </a>
        </div>
        <ul
          className={`border-t border-theme-29 py-5 ${showMenu ? "" : "hidden"}`}
        >
          {auth.userMeta &&
            auth.userMeta.panel_menus &&
            auth.userMeta.panel_menus.length > 0 &&
            auth.userMeta.panel_menus.map((item, index) => (
              item.allow && (
                <li key={`mobile_item_${index}`}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveMenu(activeMenu === item.to ? "" : item.to);
                    }}
                    className={`menu ${activeMenu === item.to ? "menu--active" : ""}`}
                  >
                    <div className="menu__icon">
                      <IconLoader name={item.icon} />
                    </div>
                    <div className="menu__title">
                      {item.title}
                      {item.childs.length > 0 && (
                        <Icons.ChevronDown className="menu__sub-icon" />
                      )}
                    </div>
                  </a>
                  <ul className={`${activeMenu === item.to ? "menu__sub-open" : ""}`}>
                    {item.childs &&
                      item.childs.length > 0 &&
                      item.childs.map((c_item, c_index) =>
                        c_item.allow && (
                          <li key={`mobile_child_${index}_${c_index}`}>
                            <Link to={c_item.to} className="menu">
                              <div className="menu__icon">
                                <IconLoader name={c_item.icon} />
                              </div>
                              <div className="menu__title">{c_item.title}</div>
                            </Link>
                          </li>
                        )
                      )}
                  </ul>
                </li>
              )
            ))}
        </ul>
      </div>
    </>
  );
}

const IconLoader = (props) => {
  const Dicn = Icons[props.name];
  return Dicn ? <Dicn {...props.rest} /> : null;
};
